import _ from 'lodash';
import WixEvent from '../events/WixEvent';

function getRowData(event) {
    let rowData;

    if (_.get(event, 'rowData')){
        rowData = JSON.parse(event.rowData);
    }

    return rowData;
}

/**
 * @callback $w.TableRowEventHandler
 * @summary Handles events fired when a table row is selected.
 * @param {$w.TableRowEvent} event The event that has occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class TableRowEvent
 * @summary Event that is fired when a table row is selected.
 * @description This event is only fired if the table is
 *  [set](https://support.wix.com/en/article/table-settings) in the Editor to
 *  select rows when clicked.
 * ![Clicking Selects Rows](images/table_settings_click_rows.png "Clicking Selects Rows")
 * @memberof $w
 * @mixes $w.Event
 */
export default class TableRowEvent extends WixEvent {
    constructor (target, event) {
        super(target, event);

        this.rowIndex = _.get(event, 'rowIndex');
        this.rowData = getRowData(event);
    }

    /**
     * @member {external:Number} rowIndex
     * @label property
     * @syntax
     * get rowIndex(): Number
     * @summary Gets the index of the selected row.
     * @description
     *  The rows in a table are zero-based and do not include the table header.
     *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
     * @snippet [TableRowEvent-all.es6=Get the selected table row information]
     * @memberof $w.TableRowEvent
     * @readonly
     */


    /**
     * @member {external:Object} rowData
     * @label property
     * @syntax
     * get rowData(): Object
     * @summary Gets the data for the selected row.
     * @description
     *  The row data is a JSON object of `columnName:cellData` key:value pairs.
     *  The object only contains the data that is displayed in the table.
     *
     *  If the table is connected to a dataset, the `rowData` does not include the
     *  fields from the dataset item that are not connected to table columns.
     *
     *  To retrieve the dataset item data that corresponds to the table row data,
     *  use the dataset [`getCurrentItem()`](wix-dataset.html#getCurrentItem)
     *  function in the dataset [`onCurrentIndexChanged()`](wix-dataset.html#onCurrentIndexChanged)
     *  event handler.
     *
     *  Getting the `rowData` gets the same object that is returned in the array
     *  of rows when readingthe table's [`rows`]($w.Table.html#rows) property.
     * @snippet [TableRowEvent-all.es6=Get the selected table row information]
     * @snippet [TableRowEvent-rowData_dataset.es6=Get the full item information from the dataset]
     * @memberof $w.TableRowEvent
     * @readonly
     */

}
